import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Global } from '../../services/global'
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/auth/services/login.service';
import { Hora } from '../models/hora';
import { Record } from '../models/record';

@Injectable({
  providedIn: 'root'
})
export class BitacoraService {

  private url: string;

  constructor(private _http: HttpClient, private loginService: LoginService) {
    this.url = Global.url;
  }

  //*Método para enviar la data de bitacora
  saveRecord(accion: string): Observable<any> {
    //preparando la data
    let usuario = this.loginService.userLogged();
    let fecha = new Date();
    let hora = new Hora(new Date().getHours(), new Date().getMinutes());

    let record = new Record(fecha, hora, usuario._id, accion);//construyendo el registro

    let params = JSON.stringify(record);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(this.url + 'bitacora/save', params, { headers: headers });
  }

  //*Método para obtener todos los registros paginados
  getRecords(page): Observable<any> {
    let params = new HttpParams().set('page', page);
    return this._http.get(this.url + 'bitacora/listar', { params });
  }

  //*Método para obtener la lista de records paginanos y por empleado especifico
  getByUser(id, page): Observable<any> {
    let params = new HttpParams().set('id', id).set('page', page);
    return this._http.get(this.url + 'bitacora/findByUser', { params });
  }

  //*Método para eliminar un registro
  delete(id): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.delete(this.url + 'bitacora/delete/' + id, { headers: headers });
  }


}
